import FilledInputLightMixin from './filled-input-light-mixin.js';
import FilledFloatingLabelInputBaseMixin from './filled-floating-label-input-base-mixin.js';

function FilledFloatingLabelInputLightMixin(Base) {

  return class FilledFloatingLabelInputLight extends
    FilledInputLightMixin(
    FilledFloatingLabelInputBaseMixin(
      Base
  )) {}

}

export default FilledFloatingLabelInputLightMixin;
